import { useEffect, useState } from "react";
import { Loader } from "./Loader";
import { ErrorMessage } from "./ErrorMessage";
import { NavBar } from "./NavBar";
import { Main } from "./Main";
import { NumResults } from "./NumResults";
import { Box } from "./Box";
import { Search } from "./Search";
import { MovieList } from "./MovieList";
import { WatchedMoviesList } from "./WatchedMoviesList";
import { MovieDetails } from "./MovieDetails";
import { WatchedSummary } from "./WatchedSummary";
import { useMovies } from "./useMovies";
import { useLocalStorageState } from './useLocalStorageState';

export const average = (arr) =>
  arr.reduce((acc, cur, i, arr) => acc + cur / arr.length, 0);
export const KEY = process.env.REACT_APP_OMDB_API_KEY;

export default function App() {
  const [query, setQuery] = useState("");

  const [selectedId, setSelectedId] = useState(null);
  const { movies, isLoading, error } = useMovies(query);

  const [watched, setWatched] = useLocalStorageState([],'watched');


  function handleSelectMovie(id) {
    return setSelectedId(function (selectedId) {
      return id === selectedId ? null : id;
    });
  }

  function handleCloseMovie() {
    return setSelectedId(null);
  }

  function handleAddWatched(movie) {
    setWatched(function (watched) {
      return [...watched, movie];
    });
  }

  function handleDeleteWatched(id) {
    setWatched(function (watched) {
      return watched.filter(function (movie) {
        return movie.imdbID !== id;
      });
    });
  }



  return (
    <>
      <NavBar>
        <Search query={query} setQuery={setQuery} />
        <NumResults>
          Found <strong>{movies?.length}</strong> results
        </NumResults>
      </NavBar>

      <Main>
        <Box>
          {/*{isLoading ? <Loader /> : <MovieList movies={movies} />}*/}
          {isLoading && <Loader />}
          {isLoading && !error ? (
            <Loader />
          ) : (
            <MovieList movies={movies} onSelectMovie={handleSelectMovie} />
          )}
          {error && <ErrorMessage message={error} />}
        </Box>
        <Box>
          {selectedId ? (
            <MovieDetails
              selectedId={selectedId}
              onCloseMovie={handleCloseMovie}
              onAddWatched={handleAddWatched}
              watched={watched}
            />
          ) : (
            <>
              <WatchedSummary watched={watched} />
              <WatchedMoviesList
                watched={watched}
                onDeleteWatched={handleDeleteWatched}
              />
            </>
          )}
        </Box>
      </Main>
    </>
  );
}
